import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBanner, updateBanner } from 'slice/bannerSlice';
import { useParams, useNavigate } from 'react-router-dom';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { oneData, loading } = useSelector((state) => state.banner);
    
    const [formData, setFormData] = useState({
        title: '',
        image: null,
        currentImage: ''
    });

    useEffect(() => {
        dispatch(getOneBanner(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setFormData({
                title: oneData.title || '',
                image: null,
                currentImage: oneData.image || ''
            });
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image') {
            setFormData(prev => ({ ...prev, image: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('title', formData.title);
        if (formData.image) {
            data.append('image', formData.image);
        }

        dispatch(updateBanner({ id, data }));
        setTimeout(() => navigate('/khajuraho/banners'), 1500);
    };

    const getImageUrl = (img) => {
        const backend = process.env.REACT_APP_BACKEND || "http://localhost:8001/";
        const base = backend.endsWith('/') ? backend : backend + '/';
        return `${base}uploads/${img.trim()}`;
    };

    return (
        <div className="container-fluid mt-5 pb-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Banner</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-12 mt-2">
                        <label htmlFor="title" className="adminlables">Banner Title</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            className="form-control"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="image" className="adminlables">Change Image (Optional)</label>
                        <input
                            type="file"
                            id="image"
                            name="image"
                            className="form-control btn-block filebg"
                            onChange={handleChange}
                        />
                    </div>
                    {formData.currentImage && (
                        <div className="col-sm-12 mt-3">
                            <span className="adminlables d-block">Current Image:</span>
                            <img src={getImageUrl(formData.currentImage)} alt="Current banner" width={200} className="rounded shadow-sm" />
                        </div>
                    )}
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Banner'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Update;
